// extracted by mini-css-extract-plugin
module.exports = {"line":"styles_line__2UUfn","shimmer":"styles_shimmer__3X-jc","medium":"styles_medium__IzHIu","short":"styles_short__2MuzU"};